fx.ns("repositories", class ThemesRepository extends fx.ModelArray {

    constructor()
    {
        super([]);

        this.endpoint = "/app/themes";

        this._tags = [];
    }

    get themetags()
    {
        return this._themetags;
    }

    load(tag, active, lang)
    {
        tag = (tag instanceof models.ThemeTag) ? tag.id : tag;

        if (this._tags.indexOf(tag) != -1)
            this.event("themes-loaded");
        else
        {
            this._tags.push(tag);

            this.post( 
                { 
                    action: active ? "activethemes" : "themes",
                    theme_tag_id :tag,
                    lang : lang
               }, 
               this._loaded);
        }
        
    }

    _loaded(data)
    {
        if (data.error)
        {
            this.event("connection-error", data);
        }
        else
        {
            this.addItem(data, true);
            this.event("themes-loaded");
        }
    }

    getThemes(tag)
    {
        let tagid =  tag instanceof models.ThemeTag ? tag.id : tag;
        return this.filter( function(theme) { return theme.theme_tag_id ==tagid;});
    }

    getTag(theme)
    {
        return this.themetags.find({id : theme.theme_tag_id});
    }

    getFirst(tag)
    {
        return this.getThemes(tag).sort(function(a, b) { return b.position - a.position})[0];
    }

    getThemeTags()
    {
        if (this.themetags)
            this.event("theme-tags-loaded");
        else
            this.post( 
                { 
                    action:"tags",
               }, 
               this._getThemeTags);
    }

    _getThemeTags(data)
    {
        if (data.error)
        {
            this.event("connection-error", data);
        }
        else
        {
            this.initThemeTags(data);
            this.event("theme-tags-loaded");
        }
    }

    initThemeTags(data)
    {
        this._themetags = new fx.ModelArray(data);
    }

    getCollection(themetag)
    {
        if(themetag.collection)
            this.event("theme-tags-collection-loaded");
        else
        this.post( 
            { 
                action:"collection",
                theme_tag_id : themetag.id,
                id_lang : fx.service("LangService").current.id
           }, 
           this._getCollection);
    }

    _getCollection(data)
    {
        if (data.error)
        {
            this.event("theme-tags-collection-error", data);
        }
        else
        {
            let themetag = this.themetags.find({id : data.id});
            themetag.collection = new fx.ModelArray( data.collection );
            this.event("theme-tags-collection-loaded");
        }
    }

	getThemelayouts(theme)
	{
        if (theme.layouts && theme.layouts.length > 0)
            this.event("theme-layouts-loaded", theme);
        else
		this.post( 
            { 
                action:"layouts",
                themeid : theme.id
           }, 
           this._getThemelayouts);
    }
    
    _getThemelayouts(data)
    {
        if (data.error)
        {
            //this.event("server-error", data);
            this.event("get_theme_layout-error", data);
        }
        else
        {
            let theme = this.find({id : data.id});
            theme.set("layouts",  data.layouts);
            theme.status = data.status;
            this.event("theme-layouts-loaded", theme);
        }
    }


    copyLayouts(themeid, shape)
    {
        this.post( 
            { 
                action:"copylayouts",
                themeid : themeid,
                shape : shape
           }, 
           this._copyLayouts);

        let layouts = fx.get("themes").find({id : themeid}).layouts;
        for (let i = 0; i < layouts.length; i++)
            if (layouts.getItemAt(i).shape != shape)
                layouts.getItemAt(i).thumb = "";
           
    }

    _copyLayouts(data)
    {
        if (data.error)
        {
            //this.event("server-error", data);
            this.event("copy-layouts-error", data);
        }
        else
        {
            this.event("theme-layouts-copied");
        }  
    }


    copyTheme(source , target)
    {
        this.post( 
            { 
                action:"copytheme",
                source : source.id,
                target : target.id
           }, 
           this._copyTheme);        
    }

    _copyTheme(data)
    {
        let theme = this.find({id : data});
        theme.set("layouts",  []);

        theme.event("theme-pasted");
    }


    newTheme(name, themeTag, id_lang)
    {
        this.post( 
            { 
                action:"new", 
                name : name,
                theme_tag_id : themeTag.id,
                id_lang : id_lang
           }, 
           this._newTheme);
    }

    _newTheme(data)
    {
        if (data.error)
            this.event("new-theme-error", data);
        else
        {
            this.addItem(data, false);
            this.event("theme-added");
        }
    }

});